var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloudBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8144_151414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3334 26.3332L23 22.9999M23 22.9999L19.6667 26.3332M23 22.9999V30.4999M29.9917 28.3249C30.8045 27.8818 31.4466 27.1806 31.8166 26.3321C32.1866 25.4835 32.2635 24.5359 32.0352 23.6388C31.8069 22.7417 31.2863 21.9462 30.5556 21.3778C29.8249 20.8094 28.9257 20.5005 28 20.4999H26.95C26.6978 19.5243 26.2277 18.6185 25.575 17.8507C24.9223 17.0829 24.1041 16.4731 23.1818 16.0671C22.2595 15.661 21.2572 15.4694 20.2501 15.5065C19.2431 15.5436 18.2576 15.8085 17.3677 16.2813C16.4778 16.7541 15.7066 17.4225 15.1122 18.2362C14.5178 19.05 14.1156 19.9879 13.9358 20.9794C13.7561 21.9709 13.8034 22.9903 14.0744 23.961C14.3453 24.9316 14.8327 25.8281 15.5 26.5832",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8144_151414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudBlack);
export default __webpack_public_path__ + "static/media/uploadCloudBlack.d91625ee09aefb471aa7e46ec8bb07a1.svg";
export { ForwardRef as ReactComponent };